<template>
  <div class="banner-bar">
    <div class="banner-bar__content wrap">
      <div class="label">{{label}}</div>
      <div class="desc">{{desc}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerBar',
  props: {
    label: String,
    desc: String
  }
}
</script>

<style lang="less" scoped>
.banner-bar {
  height: 420px;
  background: url("~@/assets/images/banner.jpg") no-repeat;
  background-size: cover;
  background-position: center center;
  text-align: center;
  &__content {
    padding-top: 140px;
    padding-left: 40px;
    color: #fff;
    .label,
    .desc {
      text-align: left;
    }
    .label {
      font-size: 48px;
      line-height: 100%;
    }
    .desc {
      margin-top: 20px;
      font-size: 24px;
      line-height: 100%;
    }
  }
}
</style>
